import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './shared/contexts/AuthContext';
import './shared/styles/global.css';

// SaleSide Pages
import HomePage from './saleside/pages/home/HomePage';
import BusinessSignUpPage from './saleside/pages/signup/BusinessSignUpPage';
import BusinessSignInPage from './saleside/pages/signin/BusinessSignInPage';
import PricingPage from './saleside/pages/pricing/PricingPage';
import AboutPage from './saleside/pages/about/AboutPage';

// DashboardSide Pages
import DashboardLayout from './dashboardside/components/DashboardLayout/DashboardLayout';
import DashboardPage from './dashboardside/pages/dashboard/DashboardPage';
import MembersPage from './dashboardside/pages/members/MembersPage';
import MyAccountPage from './dashboardside/pages/myaccount/MyAccountPage';
import HelpPage from './dashboardside/pages/help/HelpPage';

// CustomerSide Pages
import RewardEarnedPage from './customerside/pages/rewardearned/RewardEarnedPage';
import RewardRedeemedPage from './customerside/pages/redeemed/RewardRedeemedPage';
import CustomerFailedTapPage from './customerside/pages/failedtap/CustomerFailedTapPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* SaleSide Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/businesssignup" element={<BusinessSignUpPage />} />
            <Route path="/businesssignin" element={<BusinessSignInPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/about" element={<AboutPage />} />
            
            {/* DashboardSide Routes */}
            <Route path="/dashboard" element={<DashboardLayout><DashboardPage /></DashboardLayout>} />
            <Route path="/members" element={<DashboardLayout><MembersPage /></DashboardLayout>} />
            <Route path="/myaccount" element={<DashboardLayout><MyAccountPage /></DashboardLayout>} />
            <Route path="/help" element={<DashboardLayout><HelpPage /></DashboardLayout>} />
            
            {/* CustomerSide Routes */}
            <Route path="/earned" element={<RewardEarnedPage />} />
            <Route path="/redeemed" element={<RewardRedeemedPage />} />
            <Route path="/tapfailed" element={<CustomerFailedTapPage />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
